import React from "react";
import { Card, Col } from "react-bootstrap";
import './StatusCard.css';


const StatusCard = ({ count = 0, status = "Pending"}) => {
  let statusIcon = <svg width="80" height="80" viewBox="0 0 80 80" fill="none" style={{ opacity: 0.08 }}>
    <circle cx="40" cy="40" r="36" stroke="#FF9800" strokeWidth="4" />
    <path d="M40 20v20l14 8" stroke="#FF9800" strokeWidth="4" strokeLinecap="round" />
    <rect x="36" y="56" width="8" height="8" rx="2" fill="#FF9800" />
  </svg>;
  let statusCOlor = "#F76B1C";
  let statusClass = "";
  let statusText = "Total Courses";
  if (status === "Pending") {
    statusCOlor = "#F76B1C";
    statusClass = "pending-card";
    statusText = "Pending Courses";
    statusIcon = <svg width="80" height="80" viewBox="0 0 80 80" fill="none" >
      <circle cx="40" cy="40" r="36" stroke="#FF9800" strokeWidth="4" />
      <path d="M40 20v20l14 8" stroke="#FF9800" strokeWidth="4" strokeLinecap="round" />
      <rect x="36" y="56" width="8" height="8" rx="2" fill="#FF9800" />
    </svg>;
  } else if (status === "published") {
    statusCOlor = "#1D660F";
    statusClass = "published-card";
    statusText = "Published Courses";
    statusIcon = <svg width="80" height="80" viewBox="0 0 80 80" fill="none" >
      <circle cx="40" cy="40" r="36" stroke="#4CAF50" strokeWidth="4" />
      <path d="M30 40l10 10 20-20" stroke="#4CAF50" strokeWidth="4" strokeLinecap="round" />
    </svg>;
  } else if (status === "Rejected") {
    statusClass = "rejected-card";
    statusCOlor = "#EA4335";
    statusText = "Rejected Courses";
    statusIcon = <svg width="80" height="80" viewBox="0 0 80 80" fill="none" >
      <circle cx="40" cy="40" r="36" stroke="#F44336" strokeWidth="4" />
      <path d="M30 30l20 20M50 30l-20 20" stroke="#F44336" strokeWidth="4" strokeLinecap="round" />
    </svg>;
  } else if (status === 'total' || status === "Total") {
    statusCOlor = "#231444";
    statusClass = "total-card";
    statusIcon = <svg width="80" height="80" viewBox="0 0 80 80" fill="none" >
      <circle cx="40" cy="40" r="36" stroke="#2196F3" strokeWidth="4" />
      <path d="M40 20v20l14-8M40 60h8v-8h-8zM32 60h8v-8h-8zM24 60h8v-8h-8zM16 60h8v-8h-8zM48 60h8v-8h-8zM56 60h8v-8h-8zM64 60h8v-8h-8zM72 60h8v-8h-8z"
        stroke="#2196F3"
        strokeWidth="4"
        strokeLinecap="round"
      />
    </svg>;
  }
  return (
    <Col lg={3} sm={12} className="mb-4">
      <Card className={`statusCard ${statusClass} text-center`}>
        <div className="statusIcon"> {statusIcon}</div>
        <Card.Body className="course-status-card">
          <Card.Title
            style={{ color: statusCOlor, fontWeight: 700, fontSize: 48, marginBottom: 4 }}>{count}</Card.Title>
          <Card.Text style={{ color: statusCOlor, fontWeight: 500, fontSize: 18, textAlign: "center" }} >
            ({statusText})
          </Card.Text>
        </Card.Body>
      </Card>
    </Col>
  )

};

export default StatusCard;